import React, { useState } from "react";
import { getDatabase } from "../../Table";
import "./Pages.css";
const rowsPerPage = 21;
export const Pagination = ({ id }) => {
  const [btnNum, setBtnNum] = useState(0);
  var db = getDatabase();
  var t1 = () => {
      var l = [];
      for (var i = 0; i < rowsPerPage; i++) {
        l.push(db[i]);
      }

      return l;
    },
    t2 = () => {
      var l = [];
      l.push(db[0]);
      for (var i = 21; i < 41; i++) {
        l.push(db[i]);
        }
      return l;
     },
      t3 = () => {
          var l = [];
          l.push(db[0]);
          for (var i = 41; i < 61; i++) {
              l.push(db[i]);
          }
          return l;
        },
      t4 = () => {
          var l = [];
          l.push(db[0]);
          for (var i = 61; i < 81; i++) {
              l.push(db[i]);
          }
          return l;
        },
    t5 = () => {
        var l = [];
        l.push(db[0]);
        for (var i = 81; i < 101; i++) {
            l.push(db[i]);
        }
        return l;
    };
  return (
    <div id="dataContainer">
          <div id="shopifyData">{btnNum === 0 || btnNum === 1 ? t1() : btnNum == 2 ? t2() : btnNum == 3 ? t3() : btnNum===4?t4():t5()}</div>
          {(btnNum === 0 || btnNum === 1) ?
              (<div id="pageNav">
                  <button
                      id="Button1"
                      className="pageNav focused"
                      onClick={() => setBtnNum(1)}
                     
                  >
                      1
                  </button>
                  <button
                      id="Button2"
                      className="pageNav idle"
                      
                      onClick={() => setBtnNum(2)}
                  >
                      2
                </button>
                  <button
                      id="Button3"
                      className="pageNav idle"
                      onClick={() => setBtnNum(3)}
                      
                  >
                      3
                </button>
                  <button
                      id="Button4"
                      className="pageNav idle"
                      
                      onClick={() => setBtnNum(4)}
                  >
                      4
        </button>
                  <button
                      id="Button5"
                      className="pageNav idle"
                      
                      onClick={() => setBtnNum(5)}
                  >
                      5
        </button>
              </div>) : (btnNum === 2 ? (<div id="pageNav">
                  <button
                      id="Button1"
                      className="pageNav idle"
                      onClick={() => setBtnNum(1)}
                      
                  >
                      1
        </button>
                  <button
                      id="Button2"
                      className="pageNav focused"
                      
                      onClick={() => setBtnNum(2)}
                  >
                      2
        </button>
                  <button
                      id="Button3"
                      className="pageNav idle"
                      onClick={() => setBtnNum(3)}
                      
                  >
                      3
        </button>
                  <button
                      id="Button4"
                      className="pageNav idle"
                     
                      onClick={() => setBtnNum(4)}
                  >
                      4
        </button><button
                      id="Button5"
                      className="pageNav idle"

                      onClick={() => setBtnNum(5)}
                  >
                      5
        </button></div>) : (btnNum === 3 ? (<div id="pageNav">
                      <button
                          id="Button1"
                          className="pageNav idle"
                          onClick={() => setBtnNum(1)}
                          
                      >
                          1
        </button>
                      <button
                          id="Button2"
                          className="pageNav idle"
                       
                          onClick={() => setBtnNum(2)}
                      >
                          2
        </button>
                      <button
                          id="Button3"
                          className="pageNav focused"
                          onClick={() => setBtnNum(3)}
                          
                      >
                          3
        </button>
                      <button
                          id="Button4"
                          className="pageNav idle"
                         
                          onClick={() => setBtnNum(4)}
                      >
                          4
        </button><button
                          id="Button5"
                          className="pageNav idle"

                          onClick={() => setBtnNum(5)}
                      >
                          5
        </button></div>) : btnNum===4?<div id="pageNav">
                          <button
                              id="Button1"
                              className="pageNav idle"
                              onClick={() => setBtnNum(1)}
                              
                          >
                              1
        </button>
                          <button
                              id="Button2"
                              className="pageNav idle"
                              
                              onClick={() => setBtnNum(2)}
                          >
                              2
        </button>
                          <button
                              id="Button3"
                              className="pageNav idle"
                              onClick={() => setBtnNum(3)}
                              
                          >
                              3
        </button>
                          <button
                              id="Button4"
                              className="pageNav focused"
                              
                              onClick={() => setBtnNum(4)}
                          >
                              4
        </button><button
                              id="Button5"
                              className="pageNav idle"

                              onClick={() => setBtnNum(5)}
                          >
                              5
        </button></div>:<div id="pageNav">
                              <button
                                  id="Button1"
                                  className="pageNav idle"
                                  onClick={() => setBtnNum(1)}

                              >
                                  1
        </button>
                              <button
                                  id="Button2"
                                  className="pageNav idle"

                                  onClick={() => setBtnNum(2)}
                              >
                                  2
        </button>
                              <button
                                  id="Button3"
                                  className="pageNav idle"
                                  onClick={() => setBtnNum(3)}

                              >
                                  3
        </button>
                              <button
                                  id="Button4"
                                  className="pageNav idle"

                                  onClick={() => setBtnNum(4)}
                              >
                                  4
        </button><button
                                  id="Button5"
                                  className="pageNav focused"

                                  onClick={() => setBtnNum(5)}
                              >
                                  5
        </button>
                      </div>))}
    
    </div>
  );
};
